export default __webpack_public_path__ + "static/media/C2QB_white_btn_lg_hover.a2a06104.png";